import { HttpClient } from '@angular/common/http';
import { inject, Injectable, OnInit } from '@angular/core';
import { SnackService } from './snack.service';
import { serverurl } from '../../environments/environment';
import { GdprObligationCheckResponse, ProcessingActivity } from '../lib/interfaces/gdpr-processing-activities';

@Injectable({
    providedIn: 'root'
})
export class GdprService {

    http = inject(HttpClient);
    snack = inject(SnackService);

    /*
        router.post('/processing-activities', processActivities);
        router.get('/processing-activities', getAllActivities);
        router.get('/processing-activities/special-categories', getActivitiesWithSpezCats);
        router.get('/processing-activities/:id', getActivitiesById);
        router.put('/processing-activities/:id', updateActivity);
        router.delete('/processing-activities/:id', deleteActivity);
        router.get('/export', exportWithSpecialCategories);
        router.get('/export-supervisory-authority', exportForSupervisor);
        router.get('/obligation-check', checkObligation);
    */

    async getAllProcessingActivities(status: string | undefined): Promise<ProcessingActivity[] | false> {
        return await new Promise((resolve) => {
            let url = `${serverurl}/gdpr/processing-activities`;
            if (status) {
                url += `?status=${status}`;
            }
            this.http.get(url).subscribe({
                next: (data: any) => {
                    resolve(data);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
    async createProcessingActivities(activityData: any): Promise<boolean> {
        return await new Promise((resolve) => {
            const url = `${serverurl}/gdpr/processing-activities`;
            this.http.post(url, activityData).subscribe({
                next: (data: any) => {
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
    async updateProcessingActivities(id: string, activityData: any): Promise<boolean> {
        return await new Promise((resolve) => {
            const url = `${serverurl}/gdpr/processing-activities/${id}`;
            this.http.put(url, activityData).subscribe({
                next: (data: any) => {
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
    async deleteProcessingActivities(id: string): Promise<boolean> {
        return await new Promise((resolve) => {
            const url = `${serverurl}/gdpr/processing-activities/${id}`;
            this.http.delete(url).subscribe({
                next: (data: any) => {
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }

    async getProcessingActivitiesWithSpecialCategories(): Promise<ProcessingActivity | false> {
        return await new Promise((resolve) => {
            const url = `${serverurl}/gdpr/processing-activities/special-categories`;
            this.http.get(url).subscribe({
                next: (data: any) => {
                    resolve(data);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }

    async checkObligation(employeeCount: number): Promise<GdprObligationCheckResponse | false> {
        return await new Promise((resolve) => {
            const url = `${serverurl}/gdpr/obligation-check?employeeCount=${employeeCount}`;
            this.http.get(url).subscribe({
                next: (data: any) => {
                    resolve(data);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
}
